import React, { useEffect, useState, useRef } from "react";
import "./typography.css";
import HeroSection from "./Components/HeroSection/heroSection";
import PersonalDetailsForm from "./Components/LeadCaptureForm/PersonalDetailsForm";
import KeyAdvantages from "./Components/KeyAdvanctages/KeyAdvantages";
import BankingPartners from "./Components/BankingPartners/BankingPartners";
import HowItWorks from "./Components/HowItWorks/howitworks";
import Footer from "./Components/Footer/Footer";
import StepWizard from "react-step-wizard";
import OTPVerification from "./Components/OtpSection/OtpForm";
import ProfessionalInformationForm from "./Components/LeadCaptureForm/ProfessionalInfoForm";
import LoanAmount from "./Components/LoanAmount/LoanAmount";
import AccountAggregator from "./Components/AccountAggregator/AccountAggregator";
import LoanOfferPage from "./Components/offerPage/offerPage";
import CompleteApplication from "./Components/offerPage/CompleteApplication";
import LoanPreApproval from "./Components/LeadCaptureForm/LoanPreApproval";
import TermsAndConditions from "./Components/TermsCondition/TermsCondition";
import CustomizeLoan from "./Components/CustomizeLoan/customloan";
import Spinner from "./Components/Spinner/spinner";
import { KYCRedirectScreen } from "./Components/kycloadingscreen";
import ResidentialDetailsForm from "./Components/LeadCaptureForm/ResidentialDetails";
import Header from "./Components/Header/header";
import WorkDetailsForm from "./Components/LeadCaptureForm/WorkDetailsForm";
import LoanReview from "./Components/LoanReview/loanReview";
import LoanReviewPage2 from "./Components/LoanReview2/loanReview2";
import LoanApproved from "./Components/Loan-Approved/loanApproved";
import StepProgressBar from "./UIElements/stepProgressbar";
import { useSearchParams } from "react-router-dom";
import PostOfferPages from "./PostOfferPages";
import { setUserClickData } from "../../utility/setUserClickData";
import { loadGtm } from "./Utils/GtmLoader";
import { login, setOffers } from "../../store/app/appReducer";
import { useDispatch } from "react-redux";
import AAApplicationPage from "./Components/aaapplicationpage";
import KYCApplicationPage from "./Components/KYCFrame";
import { CallbackHandlerScreen } from "./Components/CallBackHanlder";
import OTPPage from "./Components/OPTPage2";
import { FinalRedirectScreen } from "./Components/finalCallback";
import callApi from "../../utility/apiCaller";
import { v6 as uuid } from 'uuid'
import {
  setAmountRequired,
  setAppId,
  setEmendateUrl,
  setInternalLead,
  setKfsUrl,
  setKycurl,
  setLeadId,
  setOpportunityId,
  setOpportunityName,
  setResponse,
  setUserData,
} from "../../store/app/aaSlice";
import LoanApprovalProcesspage from "./Components/LoanApprovalProcessPage";
import DMIDownloadScreen from "./Components/DMICPVScreen";
import MobileOtpPage from "./Components/LeadCaptureForm/MobileOtpPage";
import OfferPageAAFailed from "./Components/AAFailedOfferPage";
import IframeView from "./Components/Iframes/Iframe";
import NotEligibleOfferPage from "./Components/NotEligibleOfferPage";

const PostOfferPlaceholder = () => (
  <div className="p-6 text-center font-atkinson">
    <h2 className="text-xl mb-4">Post Offer Flow</h2>
    <p>Continue with loan review, KFS modal, etc.</p>
  </div>
);

export default function LandingPage() {
  useEffect(() => {
    loadGtm("GTM-KNNN2HFK");
  }, []);

  const stepWizardRef = useRef(null);
  const [isFormStarted, setIsFormStarted] = useState(false); //testing
  const [currentStep, setCurrentStep] = useState(null);
  // DEV preview: open the Gold Loan (not-eligible) page directly via ?ui=gold
  const __goldPreview =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("ui") === "gold";
  useEffect(() => {
    if (__goldPreview && currentStep !== 56) setCurrentStep(56);
  }, [__goldPreview, currentStep]);
  const [formData, setFormData] = useState({});
  const [params] = useSearchParams();
  const [mobile, setMobileForOtp] = useState("");
  const [showOfferHeaderLogo, setShowOfferHeaderLogo] = useState(false);
  const [loadingStep, setLoadingStep] = useState(true);
  let leadId; // = params.get("lid") || "";
  const ldId = params.get("ld_id") || "";
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const affId = params.get("aff_id") || "";
  const utmSource = params.get("utm_source") || "";
  const source = params.get("source") || "";
  const utmMedium = params.get("utm_medium") || "";
  const utmTerm = params.get("utm_term") || "";
  const adsName = params.get("ads_name") || "";
  const [applicationid, setApplicationId] = useState(""); // For application ID
  const [lead_Id, setLead_Id] = useState(""); // For lead ID
  const [responseId, setResponseId] = useState(""); // For lender/offer response ID
  const [mappedData, setMappedData] = useState(null);
  const [aaUrl, setaaUrl] = useState(null);
  const [InternalLeadId, seInternalLeadId] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [status, setStatus] = useState(null);

  const [addressState, setAddressState] = useState({
    residenceAddress: "",
    residenceWingFloorFlat: "",
    residenceBuildingName: "",
    residenceYears: "",
    residenceMonths: "",
    residence_type: "",
    permanentAddress: "",
    permanentaddressLine1: "",
    permanentaddressLine2: "",
    pincode: "",
    work_address1: "",
    work_address2: "",
    address1: "", // computed
    address2: "", // computed
  });

  useEffect(() => {
    const trackId = localStorage.getItem("track_id");
    setUserClickData({
      event_name: `page-preview-for-e2e`,
      user_id: ldId || "unknown",
      affiliate_id: affId || "No Aff_id found",
      utm_source: utmSource || utmMedium,
      utm_term: utmTerm,
    });
  }, []);

  useEffect(() => {
    console.log(addressState);
  }, [addressState]);

  function extractParams(url) {
    let lead_Id = null;
    let requestId = null;
    let status = null;

    try {
      if (!url.includes("?")) return { lead_Id, requestId, status };

      const [base, queryString] = url.split("?");
      if (!queryString) return { lead_Id, requestId, status };

      const queryParts = queryString.split("?");
      const lidPart = queryParts[0]; // first part after ?
      const otherParamsPart = queryParts[1] || "";

      if (lidPart.includes("=")) {
        const [key, value] = lidPart.split("=");
        if (key === "lid") {
          lead_Id = value;
        }
      }

      if (otherParamsPart) {
        const otherParams = new URLSearchParams(otherParamsPart);
        status = otherParams.get("Status");
        requestId = otherParams.get("Request_ID");
      }
    } catch (error) {
      console.error("Error parsing URL:", error);
    }

    return { lead_Id, requestId, status };
  }

  useEffect(() => {
    // Extract params from the URL on page load
    const { lead_Id, requestId, status } = extractParams(window.location.href);



    if (!lead_Id) setCurrentStep(1);
    if (lead_Id) setLead_Id(lead_Id);
    if (requestId) setRequestId(requestId);
    if (status) setStatus(status);

    //console.log("Extracted Params:", { lead_Id, requestId, status });
  }, []);

  useEffect(() => {
    if (!lead_Id) return;
    //console.log("Lead ID is ready:", lead_Id);
    checkAndCallApi();
  }, [lead_Id]);

  const checkAndCallApi = async () => {
    if (!lead_Id) return;

    try {
      // show loader while fetching lead
      setLoadingStep(true);

      const res = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: { _id: lead_Id },
        },
        "core"
      );
      console.log(res);

      if (res.status === "Success" && res.data?.leadList.length > 0) {
        const {
          _id = "",
          steps_completed = 0,
          application_id = "",
          dmi_lead_response_id = "",
          dmi_lead_id = "",
          dmi_offer = "",
          dmi_opportunityid = "",
          amount_required,
          kycurl = "",
          emandateurl = "",
          dmi_opportunityName = "",
          dmi_offers_details,
          token,
        } = res.data.leadList[0];

        let startStep = 1;

        seInternalLeadId(lead_Id);
        dispatch(setInternalLead(_id));
        dispatch(setResponse(dmi_lead_response_id));
        dispatch(setAppId(application_id));
        dispatch(setLeadId(dmi_lead_id));
        // dispatch(setOffers(dmi_offer));
        dispatch(setOpportunityId(dmi_opportunityid));
        dispatch(setKycurl(kycurl));
        dispatch(setAmountRequired(amount_required));
        dispatch(setKfsUrl(res.data.leadList[0].kfsurl));
        dispatch(setUserData(res.data.leadList[0]));
        dispatch(setEmendateUrl(emandateurl));
        dispatch(setOpportunityName(dmi_opportunityName));
        dispatch(setOffers(dmi_offers_details));
        dispatch(
          login({
            token: token,
          })
        );

        // 🔑 decide correct starting step
        if (!steps_completed || steps_completed === 0) {
          setCurrentStep(1);
        }
        if (steps_completed >= 3 && steps_completed <= 16 && steps_completed !== 5) {
          startStep = steps_completed + 1;
        }

        if (steps_completed === 5) {
          startStep = 55
        }



        setCurrentStep(startStep);

        // ensure StepWizard moves correctly
        setTimeout(() => {
          if (stepWizardRef.current) {
            stepWizardRef.current.goToStep(startStep);
          }
        }, 100);
      } else {
        setCurrentStep(1);
        throw new Error("Error while fetching data");
      }
    } catch (error) {
      console.error("Error calling API:", error);
    } finally {
      // hide loader once everything done
      setLoadingStep(false);
    }
  };

  // Function to update computed addresses whenever relevant fields change

  const dispatch = useDispatch();

  useEffect(() => {
    //console.log(formData);
  }, [formData]);

  useEffect(() => {
    const trackId = localStorage.getItem("track_id");
    //console.log(trackId, "track_id");
  }, []);

  const [formDataPostOffer, setFormDataPostOffer] = useState({});

  const nextStep = () => setCurrentStep((prev) => prev + 1);
  const goToPostOffer = () => setCurrentStep("post-offer");

  // console.log(
  //   "affId, utmTerm, utmMedium, utmSource, source,adsName",
  //   affId,
  //   utmTerm,
  //   utmMedium,
  //   utmSource,
  //   source,
  //   adsName
  // );
  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.removeItem("isFormStarted");
    };

    const sessionFlag = sessionStorage.getItem("isFormStarted");
    if (sessionFlag === "true") {
      setIsFormStarted(true);
    }
    setUserClickData({
      event_name: "pageview-multistep-pl-v1",
      user_id: ldId,
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: utmSource || utmMedium,
      utm_term: utmTerm,
    });
  }, []);

  // console.log("isFormStarted", isFormStarted);
  // console.log("currentStep", currentStep);

  // useEffect(() => {
  //   console.log("offer is set");
  //   const latestOffer = offer.data.callbackList;
  //   // console.log(latestOffer);
  //   dispatch(setOffers(latestOffer));
  // }, []);

  if (!currentStep) {
    return (
      <div className="h-full min-h-[100dvh] w-full max-w-[400px] mx-auto flex justify-center items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="plv17-app w-full flex flex-col items-center overflow-y-scroll no-scrollbar max-w-[400px] mx-auto bg-white overflow-x-hidden">
      {loadingStep && leadId ? (
        // Show loader while deciding the right step
        <div className="flex items-center justify-center h-screen">
          <Spinner />
          <p className="ml-2">Loading your application...</p>
        </div>
      ) : (
        <>
          {currentStep === 1 && (
            <>
              <MobileOtpPage
                isFormStarted={isFormStarted}
                setIsFormStarted={() => {
                  sessionStorage.setItem("isFormStarted", "true");
                  setIsFormStarted(true);
                }}
                setCurrentStep={setCurrentStep}
                currentStep={currentStep}
                formData={formData}
                setFormData={setFormData}
              />
            </>
          )}

          {currentStep === 2 && (
            <div className="w-full max-w-[400px]">
              <PersonalDetailsForm
                formData={formData}
                setFormData={setFormData}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                isFormStarted={isFormStarted}
                setIsFormStarted={setIsFormStarted}
                setMobileForOTP={setMobileForOtp}
              />
            </div>
          )}

          {currentStep === "loan_amount" && (
            <div className="w-full max-w-[400px]">
              <LoanAmount
                formData={formData}
                setFormData={setFormData}
                onBack={() => setCurrentStep(2)}
                onContinue={() => setCurrentStep(3)}
              />
            </div>
          )}

          {/* {currentStep === 456 && (
            <OTPVerification
              mobile={mobile}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
            />
          )} */}

          {currentStep === 3 && (
            <ProfessionalInformationForm
              formData={formData}
              setFormData={setFormData}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              setLead_id={setLead_Id}
              setResponseId={setResponseId}
              setApplicationId={setApplicationId}
              setMappedResponse={setMappedData}
              setAAUrl={setaaUrl}
            />
          )}

          {currentStep === 4 && (
            <AccountAggregator
              setCurrentStep={setCurrentStep}
              leadId={lead_Id}
            />
          )}

          {currentStep === 5 && (
            <AAApplicationPage
              aaUrl={aaUrl}
              appId={applicationid}
              setcurrentStep={setCurrentStep}
              currentstep={currentStep}
            />
          )}

          {currentStep === 55 && <OfferPageAAFailed />}

          {currentStep === 56 && (
            <NotEligibleOfferPage
              setCurrentStep={setCurrentStep}
              setSelectedOffer={setSelectedOffer}
            />
          )}

          {currentStep === 6 && (
            <LoanOfferPage
              formdata={formData}
              responseId={responseId}
              applicationId={applicationid}
              MappedData={mappedData}
              aaUrl={aaUrl}
              setSelectedOffer={setSelectedOffer}
              setCurrentStep={setCurrentStep}
            />
          )}

          {currentStep === "complete_application" && (
            <CompleteApplication
              selectedOffer={selectedOffer}
              setCurrentStep={setCurrentStep}
            />
          )}

          {currentStep === 61 && (
            <IframeView
            />
          )}

          {currentStep === 7 && (
            <LoanPreApproval
              setCurrentStep={setCurrentStep}
              selectedOffer={selectedOffer}
            />
          )}

          {currentStep === 8 && (
            <TermsAndConditions
              setCurrentStep={setCurrentStep}
              selectedOffer={selectedOffer}
            />
          )}

          {currentStep === 9 && (
            <CustomizeLoan
              selectedOffer={selectedOffer}
              setCurrentStep={setCurrentStep}
            />
          )}

          {currentStep === 10 && (
            <KYCApplicationPage
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
            />
          )}

          {currentStep === 11 && (
            <ResidentialDetailsForm
              setAddressState={setAddressState}
              setCurrentStep={setCurrentStep}
            />
          )}

          {currentStep === 12 && (
            <WorkDetailsForm
              addressState={addressState}
              setCurrentStep={setCurrentStep}
              setAddressState={setAddressState}
            />
          )}

          {currentStep === 13 && (
            <CallbackHandlerScreen setCurrentStep={setCurrentStep} />
          )}

          {currentStep === 14 && (
            <LoanReviewPage2 setCurrentStep={setCurrentStep} />
          )}

          {currentStep === 15 && (
            <OTPPage contactPhone={mobile} setCurrentStep={setCurrentStep} />
          )}

          {currentStep === 16 && (
            <FinalRedirectScreen setCurrentStep={setCurrentStep} />
          )}

          {currentStep === 17 && (
            <LoanApprovalProcesspage setCurrentStep={setCurrentStep} />
          )}
          {currentStep === 18 && <LoanApproved />}
          {/* {currentStep === 'cpv' && <DMIDownloadScreen/>} */}
        </>
      )}
    </div>
  );
}